import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AllocationService {
  constructor(private http: HttpClient) {}
  path = '/services/listing/allocations';
  url = `${environment.api_url_v1}${this.path}`;

  public createAllocation(data) {
    return this.http.post<any>(`${this.url}`, data);
  }

  public updateAllocation(data) {
    return this.http.put<any>(`${this.url}/${data.id}`, data);
  }

  public deleteAllocation(id) {
    return this.http.delete<any>(`${this.url}/${id}`);
  }

  public getAllocations(id) {
    return this.http.get<any>(`${this.url}/${id}`);
  }
}
